



































helpers = require('../../helpers.coffee')

view_model = {
  data: () ->
    credentials:
      email: ''
      password: ''

    pristine: true
    apiErrorMessages: []

  methods:
    submit: ->
      @$validator.validateAll().then (success) =>
        @login() if success

    login: ->
      Loader.on()
      @clearApiErrors()

      new UsersResource().login(@loginSuccess, @loginFailed, @credentials)

    loginFailed: (response) ->
      Loader.off()
      @addApiError(response.body.message)

    loginSuccess: ->
      if Session.current_user.extradata.use_new_ui
        window.location = "#{process.env.NEW_URL_REEV}/auth/novo-reev"
      else
        Loader.off()
        @$router.push { name: 'contatos/leads' }
        MixpanelCtrl.start_session()

    addApiError: (message) ->
      @apiErrorMessages.push message

    clearApiErrors: ->
      @apiErrorMessages = []

  created: ->
    intercom = new IntercomCtrl
    Session.addCallback 'session_started', intercom.start
    @errors.clear()
}

exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/sessions/login.vue